// extracted by mini-css-extract-plugin
module.exports = {"cyrillicInput":"LocalizedTextInput_cyrillicInput__7TEC_"};